/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiAlbumsIdMutationRequest, PutApiAlbumsIdMutationResponse, PutApiAlbumsIdPathParams, PutApiAlbumsId400, PutApiAlbumsId401, PutApiAlbumsId403, PutApiAlbumsId404, PutApiAlbumsId500 } from "../../types/PutApiAlbumsId.ts";
import { putApiAlbumsIdMutationResponseSchema, putApiAlbumsIdMutationRequestSchema } from "../../zod/AlbumSchemas/putApiAlbumsIdSchema.ts";

function getPutApiAlbumsIdUrl({ id }: { id: PutApiAlbumsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/albums/${id}` as const }  
  return res
}

/**
 * @summary Метод редактирования альбома.
 * {@link /api/albums/:Id}
 */
export async function putApiAlbumsId({ id, data }: { id: PutApiAlbumsIdPathParams["Id"]; data?: PutApiAlbumsIdMutationRequest }, config: Partial<RequestConfig<PutApiAlbumsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiAlbumsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiAlbumsIdMutationResponse, ResponseErrorConfig<PutApiAlbumsId400 | PutApiAlbumsId401 | PutApiAlbumsId403 | PutApiAlbumsId404 | PutApiAlbumsId500>, PutApiAlbumsIdMutationRequest>({ method : "PUT", url : getPutApiAlbumsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiAlbumsIdMutationResponseSchema.parse(res.data)
}